import React, { createContext, useContext, useState } from 'react';
import DemoBookingModal from '../components/DemoBookingModal';
import FloatingDemoButton from '../components/FloatingDemoButton';

const DemoBookingContext = createContext({ openDemoBooking: () => {} });

export const useDemoBooking = () => useContext(DemoBookingContext);

export const DemoBookingProvider = ({ children }) => {
  const [open, setOpen] = useState(false);

  return (
    <DemoBookingContext.Provider value={{ openDemoBooking: () => setOpen(true) }}>
      {children}
      <FloatingDemoButton hidden={open} />
      <DemoBookingModal open={open} onClose={() => setOpen(false)} />
    </DemoBookingContext.Provider>
  );
};
